import { safeJson } from "@/lib/http";
import { supabase } from "@/lib/supabase";

const BASE = process.env.REACT_APP_BACKEND_URL;

async function call(path, method = "GET", body) {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) throw new Error("Session expirée, reconnectez-vous.");
    const r = await fetch(`${BASE}${path}`, { method, headers: { Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) }, body: body ? JSON.stringify(body) : undefined });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

const metricsInflight = new Map();
export function fetchReportMetrics(id) {
    if (!metricsInflight.has(id)) {
        const p = call(`/api/reports/dossiers/${id}/metrics`).finally(() => setTimeout(() => metricsInflight.delete(id), 60000));
        metricsInflight.set(id, p);
    }
    return metricsInflight.get(id);
}
export const startMetricsJob = (id) => call(`/api/reports/dossiers/${id}/metrics/jobs`, "POST");
export const fetchMetricsJob = (id, jobId) => call(`/api/reports/dossiers/${id}/metrics/jobs/${jobId}`);
export const fetchHolding = (id) => call(`/api/reports/dossiers/${id}/holding`);
export const setHolding = (id, siren, nom_entreprise) => call(`/api/reports/dossiers/${id}/holding`, "PUT", { siren, nom_entreprise });
export const saveReportContent = (id, sessionId, kind, patch) => call(`/api/reports/dossiers/${id}/sessions/${sessionId}/content`, "PATCH", { kind, ...patch });
export const fetchReportContent = (id, sessionId, kind) => call(`/api/reports/dossiers/${id}/sessions/${sessionId}/content?kind=${kind}`);
export const reviseReport = async (id, sessionId, kind, instruction) => {
    const { job_id } = await call(`/api/reports/dossiers/${id}/sessions/${sessionId}/revise/jobs`, "POST", { kind, instruction });
    for (;;) {
        await new Promise((r) => setTimeout(r, 3000));
        const j = await call(`/api/reports/dossiers/${id}/sessions/${sessionId}/revise/jobs/${job_id}`);
        if (j.stage === "done") return { content: j.content, revisions: j.revisions };
        if (j.stage === "error") throw new Error(j.error || "Révision IA en erreur");
    }
};

// LOT 40 — Historique des versions & corbeille (rapports procéduraux mono-session)
export const listReportVersions = (id, kind) => call(`/api/ia/dossiers/${id}/reports/${kind}/versions`);
export const getReportVersion = (id, kind, sessionId) => call(`/api/ia/dossiers/${id}/reports/${kind}/versions/${sessionId}`);
export const deleteReportVersion = (id, kind, sessionId) => call(`/api/ia/dossiers/${id}/reports/${kind}/versions/${sessionId}`, "DELETE");

export const CHARTS = [
    { key: "ca", label: "Chiffre d'affaires", color: "#132447" },
    { key: "tresorerie", label: "Trésorerie", color: "#047857" },
    { key: "charges", label: "Charges d'exploitation", color: "#B45309" },
    { key: "personnel", label: "Charges de personnel", color: "#7C3AED" },
];
